var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z",
    fill: "#37D1DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9432 21V19.2273L16.0852 15.392C16.4375 15.0511 16.733 14.7443 16.9716 14.4716C17.214 14.1989 17.3977 13.9318 17.5227 13.6705C17.6477 13.4053 17.7102 13.1193 17.7102 12.8125C17.7102 12.4716 17.6326 12.178 17.4773 11.9318C17.322 11.6818 17.1098 11.4905 16.8409 11.358C16.572 11.2216 16.267 11.1534 15.9261 11.1534C15.5701 11.1534 15.2595 11.2254 14.9943 11.3693C14.7292 11.5133 14.5246 11.7197 14.3807 11.9886C14.2367 12.2576 14.1648 12.5777 14.1648 12.9489H11.8295C11.8295 12.1875 12.0019 11.5265 12.3466 10.9659C12.6913 10.4053 13.1742 9.97159 13.7955 9.66477C14.4167 9.35795 15.1326 9.20455 15.9432 9.20455C16.7765 9.20455 17.5019 9.35227 18.1193 9.64773C18.7405 9.93939 19.2235 10.3447 19.5682 10.8636C19.9129 11.3826 20.0852 11.9773 20.0852 12.6477C20.0852 13.0871 19.9981 13.5208 19.8239 13.9489C19.6534 14.3769 19.3485 14.8523 18.9091 15.375C18.4697 15.8939 17.8504 16.517 17.0511 17.2443L15.3523 18.9091V18.9886H20.2386V21H11.9432Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoBlue);
export default __webpack_public_path__ + "static/media/two-blue.7da1884b1299851106dc2755f94cc891.svg";
export { ForwardRef as ReactComponent };